namespace Dashboard {

    export interface DocumentType {
        id: number;
        label();
    }

    class AddAPI {

        bookingId: number;
        bk;
        passengers: PassengerInfo[];
        documentTypes;
        busy: boolean;
        apiSubmitted: boolean = false;

        countries: any[];

        constructor(protected $routeParams,
                    protected dashboardBookingService,
                    protected bookingsManagerService,
                    protected addAPIService: IAddAPIService,
                    protected globalisationService,
                    private $scope : ng.IScope,
                    private resourceService : Core.ResourceService,
                    private broker
                    ) {

            this.bookingId = parseInt($routeParams.bookingId, 10);

            addAPIService.getPassengerInfo(this.bookingId).then(passengers =>{
                this.apiSubmitted = _.some(passengers, (p: PassengerInfo) => p.DetailsSubmitted);
                this.passengers = passengers;
            });

            globalisationService.getCountries().then(countries => this.countries = countries);
            this.documentTypes = addAPIService.getDocumentTypes();
        }

        submitAPI(){
            this.busy = true;
            this.addAPIService.addAPI(this.$routeParams.bookingId, this.passengers).then(() => {
                this.apiSubmitted = true;
                this.busy = false;
                this.broker.publish('apiAdded');
            }, () => {
                this.$scope.$broadcast('flash:error', this.resourceService.get('ADDAPIFAILURE'));
                this.busy = false;
            });
        }

        getDocumentTypeLabel(id) {
            const docType = _.find(this.documentTypes, (type: DocumentType) => type.id === id);
            return docType ? docType.label() : '';
        }

        getCountryName(id) {
            const country = _.find(this.countries, country => country.CountryCodeIso3 === id);
            return country ? country.Name : '';
        }
    }


    angular
        .module('dashboard')
        .controller('AddAPI', AddAPI);

}
